var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as types from './quizzActionTypes';

var initialState = {
    articleQuizzes: [],
    quizzId: null,
    previousUserAnswers: [],
    hasError: false,
    errorMessage: ''
};

var getQuizzDataSuccess = function getQuizzDataSuccess(state, action) {
    var _extends2;

    var quizzId = action.quizzId,
        quizzName = action.quizzName,
        nbSteps = action.nbSteps,
        step = action.step;

    /*
    const quizzData = { 'quizzId' : quizzId, 'quizzName': quizzName, 'quizzType' : '',
                        'quizzStep': step, 'totalQuizzStep': nbSteps, 
                        'quizzQuestion':'', 'quizzAnswers' : [] , 'quizzUserAnswers': [], 'quizzGoodAnswers': [], 
                        'quizzAnswerIsValid' : false, 'showResult': false,
                        //'quizzCompleted' : false,
    }*/

    return _extends({}, state, {
        quizzId: quizzId,
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends2 = {}, _extends2[quizzId] = _extends({}, state.articleQuizzes[quizzId], { 'quizzId': quizzId, 'quizzName': quizzName, 'quizzType': '',
            'quizzStep': step, 'totalQuizzStep': nbSteps,
            'quizzAnswerIsValid': false, 'showResult': false, 'quizzGoodAnswers': []
        }), _extends2))

    });
};

var quizzError = function quizzError(state, action) {
    var errorMessage = action.errorMessage;

    return _extends({}, state, {
        hasError: true,
        errorMessage: errorMessage
    });
};

var nextStep = function nextStep(state, action) {
    var _extends3;

    var currentQuizzId = action.quizzId;

    var updatedQuizzData = _extends({}, state.articleQuizzes[currentQuizzId]); // immutable by making a copy of the current obj
    updatedQuizzData.quizzQuestion = '';
    updatedQuizzData.quizzAnswers = [];
    updatedQuizzData.quizzUserAnswers = [];
    updatedQuizzData.quizzGoodAnswers = [];
    updatedQuizzData.quizzType = '';
    updatedQuizzData.showResult = false;
    updatedQuizzData.quizzAnswerIsValid = false;
    updatedQuizzData.quizzStep = state.articleQuizzes[currentQuizzId].quizzStep + 1;

    return _extends({}, state, {
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends3 = {}, _extends3[state.quizzId] = updatedQuizzData, _extends3))

    });
};

var getQuestionSuccess = function getQuestionSuccess(state, action) {
    var _extends4;

    //const { question, answers, questionType } = action;
    var quizzId = action.quizzId;

    var updatedQuizzData = _extends({}, state.articleQuizzes[quizzId]); // immutable by making a copy of the current obj
    updatedQuizzData.quizzQuestion = action.question;
    updatedQuizzData.quizzAnswers = action.answers;
    updatedQuizzData.quizzType = action.questionType;
    updatedQuizzData.quizzUserAnswers = [];
    updatedQuizzData.showResult = false;

    return _extends({}, state, {
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends4 = {}, _extends4[quizzId] = updatedQuizzData, _extends4))
    });
};

var resultSuccess = function resultSuccess(state, action) {
    var _extends5;

    var isValid = action.isValid,
        correctAnswers = action.correctAnswers,
        currentUserAnswers = action.currentUserAnswers;


    var updatedQuizzData = _extends({}, state.articleQuizzes[state.quizzId]); // immutable by making a copy of the current obj
    updatedQuizzData.quizzGoodAnswers = correctAnswers;
    updatedQuizzData.quizzAnswerIsValid = isValid;
    updatedQuizzData.quizzUserAnswers = currentUserAnswers;
    updatedQuizzData.showResult = true;

    return _extends({}, state, {
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends5 = {}, _extends5[state.quizzId] = updatedQuizzData, _extends5))
        //val: state.val * isValid
    });
};

var endQuizz = function endQuizz(state, action) {
    var _extends6;

    var updatedQuizzData = _extends({}, state.articleQuizzes[state.quizzId]); // immutable by making a copy of the current obj
    updatedQuizzData.showResult = false;
    updatedQuizzData.quizzName = '';
    updatedQuizzData.quizzCompleted = true;

    return _extends({}, state, {
        quizzId: null,
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends6 = {}, _extends6[state.quizzId] = updatedQuizzData, _extends6)),
        //val: 1,
        hasError: false,
        errorMessage: ''
    });
};

var hideModal = function hideModal(state, action) {
    var _extends7;

    var quizzId = action.quizzId;

    return _extends({}, state, {
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends7 = {}, _extends7[quizzId] = _extends({}, state.articleQuizzes[quizzId], {
            'showResult': false
        }), _extends7))
    });
};

var completedStep = function completedStep(state, action) {
    var _extends8;

    var currentQuizzId = action.quizzId;

    var updatedQuizzData = _extends({}, state.articleQuizzes[currentQuizzId]); // immutable by making a copy of the current obj
    updatedQuizzData.quizzCompleted = true;

    return _extends({}, state, {
        quizzId: null,
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends8 = {}, _extends8[currentQuizzId] = updatedQuizzData, _extends8))
    });
};

var setUserPreviousAnswsers = function setUserPreviousAnswsers(state, action) {
    var _extends9;

    var quizzId = action.quizzId,
        answers = action.answers;

    return _extends({}, state, {
        previousUserAnswers: _extends({}, state.previousUserAnswers, (_extends9 = {}, _extends9[quizzId] = answers, _extends9))
    });
};

var resetQuizz = function resetQuizz(state, action) {
    var _extends10;

    var updatedQuizzData = _extends({}, state.articleQuizzes[action.quizzId]); // immutable by making a copy of the current obj
    updatedQuizzData.showResult = false;
    updatedQuizzData.quizzName = '';

    return _extends({}, state, {
        quizzId: null,
        articleQuizzes: _extends({}, state.articleQuizzes, (_extends10 = {}, _extends10[action.quizzId] = {}, _extends10)),
        hasError: false,
        errorMessage: ''
    });
};

export var quizzReducers = function quizzReducers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];


    switch (action.type) {
        case types.GET_QUIZZ_DATA_SUCCESS:
            return getQuizzDataSuccess(state, action);
        case types.GET_QUIZZ_DATA_ERROR:
            return quizzError(state, action);
        case types.NEXT_STEP:
            return nextStep(state, action);
        case types.GET_QUESTION_SUCCESS:
            return getQuestionSuccess(state, action);
        case types.GET_QUESTION_ERROR:
            return quizzError(state, action);
        case types.RESULT_SUCCESS:
            return resultSuccess(state, action);
        case types.RESULT_ERROR:
            return quizzError(state, action);
        case types.END_QUIZZ:
            return endQuizz(state, action);
        case types.HIDE_MODAL:
            return hideModal(state, action);
        case types.COMPLETED_STEP:
            return completedStep(state, action);
        case types.SET_USER_PREVIOUS_ANSWERS:
            return setUserPreviousAnswsers(state, action);
        case types.RESET_QUIZZ:
            return resetQuizz(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/quizzReducers.js
// module id = 234
// module chunks = 0